module.exports = __webpack_public_path__ + "img/quest_icon_0059_lightening.c2302d5b.png";